<template>
    <div style="background-color: #00000080; flex: 1;">
        <div style="width: 100%; height: 100%; display: flex; flex-direction: column; justify-content: center; align-items: center;">
            <div class="loading_spinner_wrap">
                <img class="rotate" style="width: 60px;" src="@/assets/img/reroad_spinner_white.png" alt="">
            </div>
            <div class="loading_text">처리 중...<span class="loading_dots"></span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Loading'
}
</script>

<style scoped>

.loading_text {
    text-shadow:
        0 0 4px rgba(0, 0, 0, 0.8),
        0 0 8px rgba(0, 0, 0, 0.6),
        0 2px 4px rgba(0, 0, 0, 0.7);
    margin-top: 19px;
    font-weight: 700;
    font-size: 20px;
    color: #fff;
}

.rotate {
    animation: rotate 2.5s cubic-bezier(0.22, 0.21, 0.36, 1) infinite;
}

@keyframes rotate {
    to {
        transform: rotate(360deg);
    }
}

@-webkit-keyframes rotate {
    to {
        -webkit-transform: rotate(360deg);
    }
}

@-moz-keyframes rotate {
    to {
        transform: rotate(360deg);
    }
}

@keyframes rotate {
    0% {
        transform: rotate(0)
    }

    50% {
        transform: rotate(360deg)
    }

    100% {
        transform: rotate(0)
    }
}
</style>